module.exports = __webpack_public_path__ + "media/time-tracking.864f25204fc48f8b8fca766c1b7a7f18.svg";